import { Image, Typography } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const NotFoundImage = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const NotFoundInformation = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const NotFound = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 32px;
  position: relative;
  width: 100%;

  ${Typography.S.Typography} {
    text-align: center;
  }

  ${Image.S.Image} {
    max-height: 160px;
  }

  ${DEVICE.mobile.max} {
    gap: 16px;

    ${Image.S.Image} {
      max-width: 100%;
    }
  }
`;

export { NotFound, NotFoundImage, NotFoundInformation };
